module.exports = __webpack_public_path__ + "res/20-img_game_selected.fd4b6ed3a7aaf247100a05941bca84d7.png";